export default __webpack_public_path__ + "static/media/modelagem-negócios.729881e4.png";